import AccessTime from 'material-ui/svg-icons/device/access-time';
import autoBind from 'react-autobind';
import {CommunityInActionPhotoDialog} from './index';
import {connect} from 'react-redux';
import Divider from 'material-ui/Divider';
import InsertDriveFile from 'material-ui/svg-icons/editor/insert-drive-file';
import {List} from 'immutable';
import muiThemes from '../../../styles/teamologyTheme';
import {openCommunityInActionPhotoDialog} from '../actions';
import {withRouter} from 'react-router';

import {GridList, GridTile} from 'material-ui/GridList';
import React, {Component, PropTypes} from 'react';

class LessonDetailSideBar extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  bindDownloadHandler(handler, id) {
    return handler.bind(null, id);
  }

  displaySingleMaterial(material, onDownloadMaterial) {
    return (
      <div key={material.get('id')} className="material" onClick={this.bindDownloadHandler(onDownloadMaterial, material.get('id'))}>
        <InsertDriveFile style={{color: muiThemes.palette.primary1Color}} />{material.get('title')}
      </div>
    );
  }

  handlePhotoClick(event) {
    if (!event.target && !event.target.src) return;
    this.props.openCommunityInActionPhotoDialog(event.target.src);
  }

  displayMaterials(materials, supplies, onDownloadMaterial) {
    if (!materials.size && !supplies.size) return <div className="no-material-msg">None</div>;
    return materials.map(m => this.displaySingleMaterial(m, onDownloadMaterial));
  }

  displaySupplies(supplies) {
    return supplies.map(supply => <div key={supply.get('id')} className="supply"><InsertDriveFile style={{color: muiThemes.palette.primary1Color}} />{supply.get('text')}</div>);
  }

  render() {
    const {estimatedTimeTaken, materials, supplies, photos, onDownloadMaterial} = this.props;

    const dividerStyle = {
      backgroundColor: '#D5D6D5',
    };

    return (
      <div>
        {
          estimatedTimeTaken
          ? <div>
              <div className="lesson-detail-estimated-time">
                <div><AccessTime style={{color: muiThemes.palette.primary1Color}} /> {estimatedTimeTaken} min</div>
              </div>
              <Divider style={dividerStyle} />
            </div>
          : <div className="lesson-detail-estimated-time" />
        }

        <div className="lesson-detail-materials">
          <div>
            <div className="sidebar-heading">Materials</div>
            {this.displayMaterials(materials, supplies, onDownloadMaterial)}
            {this.displaySupplies(supplies)}
          </div>
        </div>

        {
          photos.size > 0
            ? <div>
                <Divider style={dividerStyle} />

                <div className="lesson-detail-in-action-heading">In Action</div>
                <div className="lesson-detail-in-action">
                  <GridList cols={3} padding={15} cellHeight={50}>
                    { photos.map(photo =>
                      <GridTile
                        key={photo.get('document')}
                        cols={1}
                        rows={1} >
                        <img src={photo.get('document')} className="in-action-thumbnail" onClick={this.handlePhotoClick} />
                      </GridTile>
                    )}
                  </GridList>
                  <CommunityInActionPhotoDialog />
                </div>
              </div>
            : <div />
          }
        </div>
    );
  }
}

LessonDetailSideBar.defaultProps = {
  materials: new List(),
  photos: new List(),
  supplies: new List(),
};

LessonDetailSideBar.propTypes = {
  estimatedTimeTaken: PropTypes.number,
  materials: PropTypes.instanceOf(List),
  onDownloadMaterial: PropTypes.func.isRequired,
  openCommunityInActionPhotoDialog: PropTypes.func.isRequired,
  photos: PropTypes.instanceOf(List),
  supplies: PropTypes.instanceOf(List),
};

function mapStateToProps() {
  return {};
}

export default withRouter(connect(
  mapStateToProps,
  {
    openCommunityInActionPhotoDialog,
  }
)(LessonDetailSideBar));



// WEBPACK FOOTER //
// ./app/features/lessonDetail/components/LessonDetailSideBar.js